"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioNormalizationOrder = void 0;
var AudioNormalizationOrder;
(function (AudioNormalizationOrder) {
    AudioNormalizationOrder["FinalVideo"] = "FinalVideo";
    AudioNormalizationOrder["ClipVideo"] = "ClipVideo";
})(AudioNormalizationOrder = exports.AudioNormalizationOrder || (exports.AudioNormalizationOrder = {}));
//# sourceMappingURL=audio-normlization-order.js.map